import {computed, mounted, onUpdated} from 'vue'
import {useStore} from 'vuex'

export default {
    name: "SiteNavigationOverlay",
    setup(){
        const store = useStore()
        const showOverlay = computed(()=>store.state.main.overlay_visible ? 'nlx-overlay--visible' : '')
        const callbackOnRemove = computed(()=>store.state.main.overlay_callback_on_remove)

        return {
            showOverlay,
            callbackOnRemove
        }
    }
}